import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || '';

const api = axios.create({ baseURL: API_URL });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token && !config.headers.Authorization) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401 && localStorage.getItem('token')) {
      localStorage.removeItem('token');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export const authService = {
  login: (email, password) => api.post('/api/auth/login', { email, password }),
  playerOptions: () => api.get('/api/auth/player-options'),
  registerPlayer: (data) => api.post('/api/auth/player-register', data),
  forgotPassword: (data) => api.post('/api/auth/forgot-password', data),
  resetPassword: (data) => api.post('/api/auth/reset-password', data),
};

export const machineService = {
  getAll: () => api.get('/api/machines'),
  create: (data) => api.post('/api/machines', data),
  update: (id, data) => api.put(`/api/machines/${id}`, data),
  reorder: (data) => api.post('/api/machines/reorder', data),
  delete: (id) => api.delete(`/api/machines/${id}`),
  testGame: (id, gameId) => api.post(`/api/machines/${id}/games/${gameId}/test`),
  control: (id, command) => api.post(`/api/machines/${id}/control`, { command }),
  pairTv: (id, pair_code) => api.post(`/api/machines/${id}/tv/pair`, { pair_code }),
  unpairTv: (id) => api.delete(`/api/machines/${id}/tv/pair`),
};

export const sessionService = {
  getActive: () => api.get('/api/sessions/active'),
  getHistory: (params) => api.get('/api/sessions/history', { params }),
  start: (data) => api.post('/api/sessions/start', data),
  end: (id, data) => api.post(`/api/sessions/${id}/end`, data),
};

export const clientService = {
  getAll: (params) => api.get('/api/clients', { params }),
  getById: (id) => api.get(`/api/clients/${id}`),
  create: (data) => api.post('/api/clients', data),
  update: (id, data) => api.put(`/api/clients/${id}`, data),
  addBalance: (id, data) => api.post(`/api/clients/${id}/add-balance`, data),
  setPassword: (id, data) => api.put(`/api/clients/${id}/password`, data),
};
export const clanService={getAll:()=>api.get('/api/clans'),ranking:()=>api.get('/api/clans/ranking'),update:(id,data)=>api.put(`/api/clans/${id}`,data),changeClan:(clientId,clan_id)=>api.put(`/api/clans/members/${clientId}/clan`,{clan_id}),setCoach:(id,data)=>api.post(`/api/clans/${id}/coaches`,data),createTeam:(id,data)=>api.post(`/api/clans/${id}/teams`,data),updateRule:(id,data)=>api.put(`/api/clans/rules/${id}`,data),addPoints:data=>api.post('/api/clans/points',data),awardMix:data=>api.post('/api/clans/mix-champion',data)};
export const tournamentService={
  public:slug=>api.get(`/api/portal/public-tournament/${slug}`),
  companyPublic:slug=>api.get(`/api/portal/company-tournaments/${slug}`),
  getAll:()=>api.get('/api/tournaments'), options:()=>api.get('/api/tournaments/options'), get:id=>api.get(`/api/tournaments/${id}`),
  create:data=>api.post('/api/tournaments',data), update:(id,data)=>api.put(`/api/tournaments/${id}`,data), delete:id=>api.delete(`/api/tournaments/${id}`),
  addTeam:(id,data)=>api.post(`/api/tournaments/${id}/teams`,data), updateTeam:(id,team,data)=>api.put(`/api/tournaments/${id}/teams/${team}`,data), deleteTeam:(id,team)=>api.delete(`/api/tournaments/${id}/teams/${team}`),
  payment:(id,team,status)=>api.put(`/api/tournaments/${id}/teams/${team}/payment`,{status}), bracket:id=>api.post(`/api/tournaments/${id}/bracket`),
  updateMatch:(id,match,data)=>api.put(`/api/tournaments/${id}/matches/${match}`,data),
  awardChampion:(id,data)=>api.post(`/api/tournaments/${id}/award-champion`,data)
};

export const reportService = {
  getDashboard: () => api.get('/api/reports/dashboard'),
  getPeriod: (params) => api.get('/api/reports/period', { params }),
};

export const gameService = {
  getAll: () => api.get('/api/games'),
  getMachines: () => api.get('/api/games/available-machines'),
  testOnMachine: (gameId, machineId) => api.post(`/api/machines/${machineId}/games/${gameId}/test`),
  create: (data) => api.post('/api/games', data),
  update: (id, data) => api.put(`/api/games/${id}`, data),
  delete: (id) => api.delete(`/api/games/${id}`),
};

export const zoneService = {
  getAll: () => api.get('/api/zones'),
  create: (data) => api.post('/api/zones', data),
  update: (id, data) => api.put(`/api/zones/${id}`, data),
  delete: (id) => api.delete(`/api/zones/${id}`),
};

export const packageService = {
  getAll: () => api.get('/api/packages'),
  create: (data) => api.post('/api/packages', data),
  update: (id, data) => api.put(`/api/packages/${id}`, data),
  delete: (id) => api.delete(`/api/packages/${id}`),
  sell: (id, data) => api.post(`/api/packages/${id}/sell`, data),
  counterCredit: (data) => api.post('/api/packages/counter-credit', data),
  holidays: () => api.get('/api/packages/holidays'),
  saveHoliday: (data) => api.post('/api/packages/holidays', data),
  deleteHoliday: (id) => api.delete(`/api/packages/holidays/${id}`),
};

export const productService = {
  getAll: () => api.get('/api/products'),
  create: (data) => api.post('/api/products', data),
  update: (id, data) => api.put(`/api/products/${id}`, data),
  delete: (id) => api.delete(`/api/products/${id}`),
  sell: (id, data) => api.post(`/api/products/${id}/sell`, data),
};

export const orderService = {
  getQueue: (status = 'pending,preparing') => api.get('/api/orders', { params: { status } }),
  setStatus: (id, status) => api.put(`/api/orders/${id}/status`, { status }),
};

export const barTabService = {
  getAll: (status = 'open') => api.get('/api/bar-tabs', { params: { status } }),
  get: (id) => api.get(`/api/bar-tabs/${id}`),
  create: (data) => api.post('/api/bar-tabs', data),
  addItem: (id, data) => api.post(`/api/bar-tabs/${id}/items`, data),
  removeItem: (id, itemId) => api.delete(`/api/bar-tabs/${id}/items/${itemId}`),
  close: (id, data) => api.post(`/api/bar-tabs/${id}/close`, data),
  cancel: (id) => api.post(`/api/bar-tabs/${id}/cancel`),
};

export const cashService = {
  current: () => api.get('/api/cash/current'),
  open: (data) => api.post('/api/cash/open', data),
  close: (data) => api.post('/api/cash/close', data),
  summary: (params) => api.get('/api/cash/summary', { params }),
  movements: (params) => api.get('/api/cash/movements', { params }),
  addMovement: (data) => api.post('/api/cash/movements', data),
  history: (params) => api.get('/api/cash/history', { params }),
  updatePaymentMethod: (id, payment_method) => api.put(`/api/cash/payments/${id}/method`, { payment_method }),
  pendingPix: () => api.get('/api/cash/pending-pix'),
};

export const financeService = {
  dashboard: (params) => api.get('/api/finance/dashboard', { params }),
  entries: (params) => api.get('/api/finance/entries', { params }),
  createEntry: (data) => api.post('/api/finance/entries', data),
  updateEntry: (id, data) => api.put(`/api/finance/entries/${id}`, data),
  deleteEntry: (id) => api.delete(`/api/finance/entries/${id}`),
  categories: () => api.get('/api/finance/categories'),
  createCategory: (data) => api.post('/api/finance/categories', data),
  recurrences: () => api.get('/api/finance/recurrences'),
  createRecurrence: (data) => api.post('/api/finance/recurrences', data),
  generateRecurrences: (month) => api.post('/api/finance/recurrences/generate', { month }),
  reconciliation: (params) => api.get('/api/finance/reconciliation', { params }),
  syncReconciliation: (month) => api.post('/api/finance/reconciliation/sync', { month }),
};

// Tela do PC (kiosk do cliente) — endpoints públicos
export const pcClientService = {
  login: (data) => api.post('/api/machine/login', data),
  logout: (data) => api.post('/api/machine/logout', data),
};

export const uploadService = {
  upload: (file) => {
    const fd = new FormData();
    fd.append('file', file);
    return api.post('/api/upload', fd, { headers: { 'Content-Type': 'multipart/form-data' } });
  },
};

export const categoryService = {
  getAll: (kind) => api.get('/api/categories', { params: kind ? { kind } : {} }),
  create: (data) => api.post('/api/categories', data),
  update: (id, data) => api.put(`/api/categories/${id}`, data),
  delete: (id) => api.delete(`/api/categories/${id}`),
};

export const teamService = {
  getAll: () => api.get('/api/team'),
  create: (data) => api.post('/api/team', data),
  update: (id, data) => api.put(`/api/team/${id}`, data),
};

export const settingsService = {
  get: () => api.get('/api/settings'),
  update: (data) => api.put('/api/settings', data),
  updatePayments: (data) => api.put('/api/settings/payments', data),
  updatePlan: (data) => api.put('/api/settings/plan', data),
  regenerateKey: () => api.post('/api/settings/regenerate-key'),
  testMp: () => api.post('/api/settings/test-mp'),
  testAsaas: () => api.post('/api/settings/test-asaas'),
  getCompanyProfile: () => api.get('/api/settings/company-profile'),
  updateCompanyProfile: (data) => api.put('/api/settings/company-profile', data),
};

export const bookingService = {
  getAll: params=>api.get('/api/bookings',{params}), create:data=>api.post('/api/bookings',data),
  update:(id,data)=>api.put(`/api/bookings/${id}`,data), blocks:()=>api.get('/api/bookings/blocks/list'),
  createBlock:data=>api.post('/api/bookings/blocks',data), deleteBlock:group=>api.delete(`/api/bookings/blocks/${group}`),
  special:()=>api.get('/api/bookings/special/list'), createSpecial:data=>api.post('/api/bookings/special',data),
  updateSpecial:(id,data)=>api.put(`/api/bookings/special/${id}`,data),
  cancelSpecial:id=>api.delete(`/api/bookings/special/${id}`),
  refundSpecial:id=>api.post(`/api/bookings/special/${id}/refund`),
  specialPackages:()=>api.get('/api/bookings/special/packages'), createSpecialPackage:data=>api.post('/api/bookings/special/packages',data),
  updateSpecialPackage:(id,data)=>api.put(`/api/bookings/special/packages/${id}`,data),
  participants:id=>api.get(`/api/bookings/special/${id}/participants`),
  addParticipant:(id,data)=>api.post(`/api/bookings/special/${id}/participants`,data),
  removeParticipant:(id,clientId)=>api.delete(`/api/bookings/special/${id}/participants/${clientId}`),
};
export const membershipService = { getAll:()=>api.get('/api/memberships'), create:data=>api.post('/api/memberships',data), update:(id,data)=>api.put(`/api/memberships/${id}`,data), delete:id=>api.delete(`/api/memberships/${id}`), assign:data=>api.post('/api/memberships/assign',data) };
export const portalService = {
  company:slug=>api.get(`/api/portal/${slug}`), login:(slug,data)=>api.post(`/api/portal/${slug}/login`,data),
  account:(slug,token)=>api.get(`/api/portal/${slug}/account`,{headers:{Authorization:`Bearer ${token}`}}),
  updateProfile:(slug,token,data)=>api.put(`/api/portal/${slug}/profile`,data,{headers:{Authorization:`Bearer ${token}`}}),
  updatePassword:(slug,token,data)=>api.put(`/api/portal/${slug}/password`,data,{headers:{Authorization:`Bearer ${token}`}}),
  uploadAvatar:(slug,token,file)=>{const fd=new FormData();fd.append('file',file);return api.post(`/api/portal/${slug}/avatar`,fd,{headers:{Authorization:`Bearer ${token}`,'Content-Type':'multipart/form-data'}})},
  machines:(slug,token,params)=>api.get(`/api/portal/${slug}/machines`,{params,headers:{Authorization:`Bearer ${token}`}}),
  games:(slug,token,params)=>api.get(`/api/portal/${slug}/games`,{params,headers:{Authorization:`Bearer ${token}`}}),
  gameClick:(slug,token,id)=>api.post(`/api/portal/${slug}/games/${id}/click`,{}, {headers:{Authorization:`Bearer ${token}`}}),
  machinePackages:(slug,token,id)=>api.get(`/api/portal/${slug}/machines/${id}/packages`,{headers:{Authorization:`Bearer ${token}`}}),
  availability:(slug,token,id,params)=>api.get(`/api/portal/${slug}/machines/${id}/availability`,{params,headers:{Authorization:`Bearer ${token}`}}),
  book:(slug,token,data)=>api.post(`/api/portal/${slug}/bookings`,data,{headers:{Authorization:`Bearer ${token}`}}),
  myBookings:(slug,token)=>api.get(`/api/portal/${slug}/my-bookings`,{headers:{Authorization:`Bearer ${token}`}}),
  cancelBooking:(slug,token,id)=>api.delete(`/api/portal/${slug}/bookings/${id}`,{headers:{Authorization:`Bearer ${token}`}}),
  pix:(slug,token,data)=>api.post(`/api/portal/${slug}/credit/pix`,data,{headers:{Authorization:`Bearer ${token}`}}),
  pixStatus:(slug,token,data)=>api.post(`/api/portal/${slug}/credit/status`,data,{headers:{Authorization:`Bearer ${token}`}}),
  purchaseOptions:(slug,token)=>api.get(`/api/portal/${slug}/purchase-options`,{headers:{Authorization:`Bearer ${token}`}}),
  packagePix:(slug,token,id)=>api.post(`/api/portal/${slug}/packages/${id}/pix`,{}, {headers:{Authorization:`Bearer ${token}`}}),
  packagePixStatus:(slug,token,data)=>api.post(`/api/portal/${slug}/packages/payment-status`,data,{headers:{Authorization:`Bearer ${token}`}}),
  groupPackages:(slug,token)=>api.get(`/api/portal/${slug}/group-packages`,{headers:{Authorization:`Bearer ${token}`}}),
  myGroups:(slug,token)=>api.get(`/api/portal/${slug}/my-groups`,{headers:{Authorization:`Bearer ${token}`}}),
  createGroup:(slug,token,data)=>api.post(`/api/portal/${slug}/my-groups`,data,{headers:{Authorization:`Bearer ${token}`}}),
  addGroupGuest:(slug,token,id,data)=>api.post(`/api/portal/${slug}/my-groups/${id}/guests`,data,{headers:{Authorization:`Bearer ${token}`}}),
  removeGroupGuest:(slug,token,id,clientId)=>api.delete(`/api/portal/${slug}/my-groups/${id}/guests/${clientId}`,{headers:{Authorization:`Bearer ${token}`}}),
  groupPix:(slug,token,id)=>api.post(`/api/portal/${slug}/my-groups/${id}/pix`,{}, {headers:{Authorization:`Bearer ${token}`}}),
  groupPaymentStatus:(slug,token,id)=>api.post(`/api/portal/${slug}/my-groups/${id}/payment-status`,{}, {headers:{Authorization:`Bearer ${token}`}}),
  registerTournament:(slug,token,id,data)=>api.post(`/api/portal/${slug}/tournaments/${id}/register`,data,{headers:{Authorization:`Bearer ${token}`}}),
  tournamentPix:(slug,token,id,teamId)=>api.post(`/api/portal/${slug}/tournaments/${id}/teams/${teamId}/pix`,{}, {headers:{Authorization:`Bearer ${token}`}}),
  tournamentPaymentStatus:(slug,token,id,teamId)=>api.post(`/api/portal/${slug}/tournaments/${id}/teams/${teamId}/payment-status`,{}, {headers:{Authorization:`Bearer ${token}`}}),
  cancelTournament:(slug,token,id,teamId)=>api.delete(`/api/portal/${slug}/tournaments/${id}/teams/${teamId}`,{headers:{Authorization:`Bearer ${token}`}}),
  subscribe:(token,data)=>api.post('/api/memberships/subscribe',data,{headers:{Authorization:`Bearer ${token}`}}),
};

// Superadmin (plataforma)
export const adminService = {
  getSystemStatus: () => api.get('/api/admin/status'),
  getTenants: () => api.get('/api/admin/tenants'),
  createTenant: (data) => api.post('/api/admin/tenants', data),
  updateTenant: (id, data) => api.put(`/api/admin/tenants/${id}`, data),
  getPlans: () => api.get('/api/admin/plans'),
  createPlan: (data) => api.post('/api/admin/plans', data),
  updatePlan: (id, data) => api.put(`/api/admin/plans/${id}`, data),
  getSettings: () => api.get('/api/admin/settings'),
  updateSettings: (data) => api.put('/api/admin/settings', data),
  testAsaas: () => api.post('/api/admin/test-asaas'),
  createSubscription: (id, data) => api.post(`/api/admin/tenants/${id}/subscription`, data),
  getSubscription: (id) => api.get(`/api/admin/tenants/${id}/subscription`),
  cancelSubscription: (id) => api.delete(`/api/admin/tenants/${id}/subscription`),
};

export const crmSetupService = {
  getFunnels: () => api.get('/api/crm/setup/funnels'),
  createFunnel: (data) => api.post('/api/crm/setup/funnels', data),
  getColumns: (funnelId) => api.get('/api/crm/setup/columns', { params: { funnel_id: funnelId } }),
  createColumn: (data) => api.post('/api/crm/setup/columns', data),
  updateColumn: (id, data) => api.put(`/api/crm/setup/columns/${id}`, data),
  reorderColumns: (columnOrders) => api.put('/api/crm/setup/columns/reorder', { column_orders: columnOrders }),
  deleteColumn: (id) => api.delete(`/api/crm/setup/columns/${id}`),
  getTags: () => api.get('/api/crm/setup/tags'),
  createTag: (data) => api.post('/api/crm/setup/tags', data),
  deleteTag: (id) => api.delete(`/api/crm/setup/tags/${id}`),
  getCustomFields: () => api.get('/api/crm/setup/custom-fields'),
  createCustomField: (data) => api.post('/api/crm/setup/custom-fields', data),
  updateCustomField: (id, data) => api.put(`/api/crm/setup/custom-fields/${id}`, data),
  deleteCustomField: (id) => api.delete(`/api/crm/setup/custom-fields/${id}`),
};

export const crmLeadService = {
  getLeads: (funnelId) => api.get('/api/crm/leads', { params: { funnel_id: funnelId } }),
  createLead: (data) => api.post('/api/crm/leads', data),
  moveLead: (id, columnId) => api.put(`/api/crm/leads/${id}`, { column_id: columnId }),
  updateLead: (id, data) => api.put(`/api/crm/leads/${id}`, data),
  addTag: (leadId, tagId) => api.post(`/api/crm/leads/${leadId}/tags`, { tag_id: tagId }),
  removeTag: (leadId, tagId) => api.delete(`/api/crm/leads/${leadId}/tags/${tagId}`),
  getNotes: (leadId) => api.get(`/api/crm/leads/${leadId}/notes`),
  addNote: (leadId, content) => api.post(`/api/crm/leads/${leadId}/notes`, { content }),
  deleteNote: (leadId, noteId) => api.delete(`/api/crm/leads/${leadId}/notes/${noteId}`),
  updateProposalStatus: (leadId, status) => api.put(`/api/crm/leads/${leadId}/proposal-status`, { status }),
  getCustomValues: (leadId) => api.get(`/api/crm/leads/${leadId}/custom-values`),
  updateCustomValues: (leadId, customValues) => api.put(`/api/crm/leads/${leadId}/custom-values`, { custom_values: customValues }),
};

export const whatsappService = {
  getInstance: () => api.get('/api/whatsapp/instance'),
  getInstances: () => api.get('/api/whatsapp/instances'),
  createInstance: () => api.post('/api/whatsapp/instance'),
  bindInstance: (instanceName) => api.post('/api/whatsapp/instance/bind', { instanceName }),
  disconnectInstance: () => api.delete('/api/whatsapp/instance'),
  getMessages: (leadId) => api.get(`/api/whatsapp/lead/${leadId}/messages`),
  sendMessage: (leadId, text) => api.post(`/api/whatsapp/lead/${leadId}/messages`, { text }),
  getCatalog: () => api.get('/api/whatsapp/catalog'),
  sendProposal: (leadId, data) => api.post(`/api/whatsapp/lead/${leadId}/proposal`, data),
};

export const crmAutomationService = {
  getAutomations: (params) => api.get('/api/crm/automations', { params }),
  createAutomation: (data) => api.post('/api/crm/automations', data),
  updateAutomation: (id, data) => api.put(`/api/crm/automations/${id}`, data),
  deleteAutomation: (id) => api.delete(`/api/crm/automations/${id}`),
  triggerNow: (id) => api.post(`/api/crm/automations/${id}/trigger-now`),
};

export default api;
